import React, { Fragment, useEffect, useState, useRef } from 'react';
import {
  Row,
  CardBody,
  Card,
  Button,
  Label,
  Table,
  ButtonGroup,
  CustomInput,
  Input,
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  Separator,
  Colxx,
} from '../../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { AudioPlayer } from './Player';
import { InputStlye, SelectStyle } from '../../style/DigitalAssistantStyle';
import Angus from '../../../../../../assets/audio/angus_docs.wav';
import Arcas from '../../../../../../assets/audio/arcas_docs.mp3';
import Asteria from '../../../../../../assets/audio/asteria_docs.wav';
import Athena from '../../../../../../assets/audio/athena_docs.wav';
import Amalthea from '../../../../../../assets/audio/amalthea_docs.wav';
import Helios from '../../../../../../assets/audio/helios_docs.wav';
import Hera from '../../../../../../assets/audio/hera_docs.wav';
import Orion from '../../../../../../assets/audio/orion_doc.mp3';
import Orpheus from '../../../../../../assets/audio/orpheus_docs.wav';
import Perseus from '../../../../../../assets/audio/perseus_docs.wav';
import Stella from '../../../../../../assets/audio/stella_docs.wav';
import Zeus from '../../../../../../assets/audio/zeus_docs.wav';
import Luna from '../../../../../../assets/audio/luna_docs.wav';
import Odysseus from '../../../../../../assets/audio/odysseus_docs.wav';
import Thalia from '../../../../../../assets/audio/thalia_docs.wav';
import Apollo from '../../../../../../assets/audio/apollo_docs.wav';
import Aurora from '../../../../../../assets/audio/aurora_docs.wav';
import Atlas from '../../../../../../assets/audio/atlas_docs.wav';
import Callista from '../../../../../../assets/audio/callista_docs.wav';
import Cordelia from '../../../../../../assets/audio/cordelia_docs.wav';
import Cora from '../../../../../../assets/audio/cora_docs.wav';
import Draco from '../../../../../../assets/audio/draco_docs.wav';
import Delia from '../../../../../../assets/audio/delia_docs.wav';
import Electra from '../../../../../../assets/audio/electra_docs.wav';
import Harmonia from '../../../../../../assets/audio/harmonia_docs.wav';
import Helena from '../../../../../../assets/audio/helena_docs.wav';
import Hermes from '../../../../../../assets/audio/hermes_docs.wav';
import Hyperion from '../../../../../../assets/audio/hyperion_docs.wav';
import Iris from '../../../../../../assets/audio/iris_docs.wav';
import Janus from '../../../../../../assets/audio/janus_docs.wav';
import Juno from '../../../../../../assets/audio/juno_docs.wav';
import Jupiter from '../../../../../../assets/audio/jupiter_docs.wav';
import Mars from '../../../../../../assets/audio/mars_docs.wav';
import Minerva from '../../../../../../assets/audio/minerva_docs.wav';
import Neptune from '../../../../../../assets/audio/neptune_docs.wav';
import Ophelia from '../../../../../../assets/audio/ophelia_docs.wav';
import Pandora from '../../../../../../assets/audio/pandora_docs.wav';
import Phoebe from '../../../../../../assets/audio/phoebe_docs.wav';
import Pluto from '../../../../../../assets/audio/pluto_docs.wav';
import Saturn from '../../../../../../assets/audio/saturn_docs.wav';
import Selene from '../../../../../../assets/audio/selene_docs.wav';
import Theia from '../../../../../../assets/audio/theia_docs.wav';
import Vesta from '../../../../../../assets/audio/vesta_docs.wav';
///New
import adriano_italian from '../../../../../../assets/audio/adriano_italian.mp3';
import amy_english_british from '../../../../../../assets/audio/amy_english_british.mp3';
import aria_english_newzeland from '../../../../../../assets/audio/aria_english_newzeland.mp3';
import arlet_catalan from '../../../../../../assets/audio/arlet_catalan.mp3';
import arthur_english_british from '../../../../../../assets/audio/arthur_english_british.mp3';
import ayanda_english_south_africa from '../../../../../../assets/audio/ayanda_english_south_africa.mp3';
import bianca_italian from '../../../../../../assets/audio/bianca_italian.mp3';
import brian_english_british from '../../../../../../assets/audio/brian_english_british.mp3';
import zayd_arabic_gulf from '../../../../../../assets/audio/zayd_arabic_gulf.mp3';
import zeina_arabic from '../../../../../../assets/audio/zeina_arabic.mp3';
import zhiyu_chinese_mandarian from '../../../../../../assets/audio/zhiyu_chinese_mandarian.mp3';

import vitoria_portegues_brazillain from '../../../../../../assets/audio/vitoria_portegues_brazillain.mp3';
import vicki_german from '../../../../../../assets/audio/vicki_german.mp3';
import thiago_portegues_brazillain from '../../../../../../assets/audio/thiago_portegues_brazillain.mp3';
import takumi_japneese from '../../../../../../assets/audio/takumi_japneese.mp3';
import sofie_dutch from '../../../../../../assets/audio/sofie_dutch.mp3';
import sergio_spanish_castilian from '../../../../../../assets/audio/sergio_spanish_castilian.mp3';
import seoyeon_korean from '../../../../../../assets/audio/seoyeon_korean.mp3';
import remi_french from '../../../../../../assets/audio/remi_french.mp3';
import olivia_english_aus from '../../../../../../assets/audio/olivia_english_aus.mp3';
import ola_polish from '../../../../../../assets/audio/ola_polish.mp3';
import niamh_english_irish from '../../../../../../assets/audio/niamh_english_irish.mp3';

import lucia_spanish_castilian from '../../../../../../assets/audio/lucia_spanish_castilian.mp3';
import lisa_dutch_beligan from '../../../../../../assets/audio/lisa_dutch_beligan.mp3';
import lea_french from '../../../../../../assets/audio/lea_french.mp3';
import laura_danish from '../../../../../../assets/audio/laura_danish.mp3';
import kajal_english_indian from '../../../../../../assets/audio/kajal_english_indian.mp3';
import jitika_czech from '../../../../../../assets/audio/jitika_czech.mp3';
import ida_norwegian from '../../../../../../assets/audio/ida_norwegian.mp3';
import hindi_kajal from '../../../../../../assets/audio/hindi_kajal.mp3';
import hindi_aditi from '../../../../../../assets/audio/hindi_aditi.mp3';
import hannah_german_austerian from '../../../../../../assets/audio/hannah_german_austerian.mp3';
import hala_arabic_gulf from '../../../../../../assets/audio/hala_arabic_gulf.mp3';
import emma_english_british from '../../../../../../assets/audio/emma_english_british.mp3';
import elin_swedish from '../../../../../../assets/audio/elin_swedish.mp3';
import daniel_german from '../../../../../../assets/audio/daniel_german.mp3';
import camila_portegues_brazillain from '../../../../../../assets/audio/camila_portegues_brazillain.mp3';
import burcu_turkish from '../../../../../../assets/audio/burcu_turkish.mp3';

import naja_danish from '../../../../../../assets/audio/naja_danish.mp3';
import mads_danish from '../../../../../../assets/audio/mads_danish.mp3';
import sofie_danish from '../../../../../../assets/audio/sofie_danish.mp3';

import suvi_finnish from '../../../../../../assets/audio/suvi_finnish.mp3';
import stephen_english_us from '../../../../../../assets/audio/stephen_english_us.mp3';

import salli_english_us from '../../../../../../assets/audio/salli_english_us.mp3';
import ruth_english_us from '../../../../../../assets/audio/ruth_english_us.mp3';
import russell_english_aus from '../../../../../../assets/audio/russell_english_aus.mp3';

import ruben_dutch from '../../../../../../assets/audio/ruben_dutch.mp3';
import raveena_english_indian from '../../../../../../assets/audio/raveena_english_indian.mp3';
import nicole_english_aus from '../../../../../../assets/audio/nicole_english_aus.mp3';

import matthew_english_us from '../../../../../../assets/audio/matthew_english_us.mp3';
import mathieu_french from '../../../../../../assets/audio/mathieu_french.mp3';
import marlene_german from '../../../../../../assets/audio/marlene_german.mp3';

import lotte_dutch from '../../../../../../assets/audio/lotte_dutch.mp3';
import liam_french_canadian from '../../../../../../assets/audio/liam_french_canadian.mp3';
import kimberly_english_us from '../../../../../../assets/audio/kimberly_english_us.mp3';

import kendra_english_us from '../../../../../../assets/audio/kendra_english_us.mp3';
import karl_icelandic from '../../../../../../assets/audio/karl_icelandic.mp3';
import joey_english_us from '../../../../../../assets/audio/joey_english_us.mp3';

import hans_germna from '../../../../../../assets/audio/hans_germna.mp3';
import joana_english_yus from '../../../../../../assets/audio/joana_english_yus.mp3';

import gregory_english_us from '../../../../../../assets/audio/gregory_english_us.mp3';
import giorgio_italian from '../../../../../../assets/audio/giorgio_italian.mp3';
import geraint_english_walsh from '../../../../../../assets/audio/geraint_english_walsh.mp3';

import gabrielle_french_canadian from '../../../../../../assets/audio/gabrielle_french_canadian.mp3';
import dora_iceandic from '../../../../../../assets/audio/dora_iceandic.mp3';
import danielle_english_us from '../../../../../../assets/audio/danielle_english_us.mp3';

import chantal_french_candian from '../../../../../../assets/audio/chantal_french_candian.mp3';
import celine_french from '../../../../../../assets/audio/celine_french.mp3';
import carla_italian from '../../../../../../assets/audio/carla_italian.mp3';
import aditi_english_indian from '../../../../../../assets/audio/aditi_english_indian.mp3';

import miguel_spanish_us from '../../../../../../assets/audio/miguel_spanish_us.mp3';
import penelope_spanish_us from '../../../../../../assets/audio/penelope_spanish_us.mp3';
import pedro_spanish_us from '../../../../../../assets/audio/pedro_spanish_us.mp3';
import mia_spanish_maxican from '../../../../../../assets/audio/mia_spanish_maxican.mp3';
import maxim_russian from '../../../../../../assets/audio/maxim_russian.mp3';
import maja_polish from '../../../../../../assets/audio/maja_polish.mp3';

import lupe_spanish_us from '../../../../../../assets/audio/lupe_spanish_us.mp3';
import jan_polish from '../../../../../../assets/audio/jan_polish.mp3';
import jacek_polish from '../../../../../../assets/audio/jacek_polish.mp3';

import astrid_sweedish from '../../../../../../assets/audio/astrid_sweedish.mp3';
import andres_spanish_mexican from '../../../../../../assets/audio/andres_spanish_mexican.mp3';
import carmen_romanian from '../../../../../../assets/audio/carmen_romanian.mp3';

import ewa_polish from '../../../../../../assets/audio/ewa_polish.mp3';
import tatyana_russian from '../../../../../../assets/audio/tatyana_russian.mp3';
import flizz_turksih from '../../../../../../assets/audio/flizz_turksih.mp3';
import gwyneth_walsh from '../../../../../../assets/audio/gwyneth_walsh.mp3';
import { Player } from './Player';
import { gAPI_ElevenLabsVoices } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Languages from '../../../../../../data/languages';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
function VoiceAndBehaviour({ settings, saveIntegration }) {
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedVoiceMulti, setSelectedVoiceMulti] = useState([]);

  const [voiceActors, setVoiceActors] = useState([]);
  const [elevenLabsVoices, setElevenLabsVoices] = useState([]);
  const [features, setFeatures] = useState({
    recording: false,
    transcribe: false,
    voiceActor: 'aura-asteria-en',
    autoLanguageDetection: false,
    realTimeStreaming: false,
    provider: '',
    voiceProcessing: 'Normal',
    agentId: '',
  });
  useEffect(() => {
    if (settings !== undefined && settings.features !== undefined) {
      setFeatures({
        recording: settings.features.recording,
        transcribe: settings.features.transcribe,
        voiceActor: settings.features.voiceActor,
        autoLanguageDetection: settings.features.autoLanguageDetection,
        realTimeStreaming: settings.features.realTimeStreaming,
        provider: settings.features?.provider || '',
        humanAssistant: settings.features.humanAssistant || false,
        ES6Format: settings.features.ES6Format || '',
        voiceProcessing: settings.features.voiceProcessing,
        agentId: settings.features.agentId || '',
      });
    }
  }, [settings]);
  useEffect(() => {
    const loadElevenVoices = async () => {
      try {
        const res = await AxiosAPI({
          method: 'get',
          url: gAPI_ElevenLabsVoices,
        });
        let list = res?.data?.voices || res?.data || [];
        if (!Array.isArray(list)) list = [];
        let mapped = list.map((v) => ({
          voice: v.name,
          accent: v.labels.accent || '',
          gender: v.labels.gender || '',
          values: v.voice_id,
          addCustomText: false,
          language: v?.labels?.language || '',
          previewUrl: v.preview_url || '',
          customText: '',
          audioFile: null,
          provider: 'ElevenLabs',
          verified_languages: v.verified_languages
            ? [
                ...new Map(
                  v.verified_languages.map((item) => [item.preview_url, item])
                ).values(),
              ]
            : [],
        }));
        if (mapped.length > 0) {
          setVoiceActors(mapped);
          setElevenLabsVoices(mapped);
          setSelectedLanguages(
            Languages.filter((v) =>
              settings?.features?.voiceSettings.some(
                (val) => val.language == v.code
              )
            ).map((m) => ({
              value: m.code,
              label: m.name,
            })) || []
          );
          setSelectedVoiceMulti(
            mapped
              .filter((v) =>
                settings?.features?.voiceSettings.some(
                  (val) => val.voiceActor == v.values
                )
              )
              .map((m) => ({
                value: m.values,
                label: `${m.voice} (${m.accent || 'N/A'}; ${m.language || 'N/A'})`,
              }))
          );
          if (features?.voiceSettings && features?.voiceSettings.length > 0) {
            const selected = mapped.filter((v) =>
              features.voiceSettings.some((s) => s.voice === v.values)
            );
          }
          setFeatures((prev) => ({
            ...prev,
            voiceActor:
              prev.voiceActor &&
              mapped.find((m) => m.values === prev.voiceActor)
                ? prev.voiceActor
                : mapped[0].values,
            provider: 'ElevenLabs',
          }));
        } else {
          NotificationManager.info(
            'No voices returned from ElevenLabs',
            '',
            3000
          );
        }
      } catch (err) {
        NotificationManager.warning(
          'Failed to load ElevenLabs voices',
          '',
          3000
        );
        // eslint-disable-next-line no-console
      }
    };
    console.log(
      settings?.features?.voiceProcessing,
      'settings?.features?.voiceProcessing'
    );
    if (settings?.features?.voiceProcessing === 'ElevenLabs') {
      loadElevenVoices();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);
  // Language filter dropdown for ElevenLabs and react-selects for voice actors

  const filterSupportedVoicesByLanguage = (voices, selectedLanguages) => {
    if (!selectedLanguages || selectedLanguages.length === 0) return voices;
    const selectedLangs = selectedLanguages.map((lang) => lang.value);
    return voices.filter((v) => selectedLangs.includes(v.language));
  };

  const handleSave = () => {
    let objFeatures = features;
    objFeatures.voiceSettings = elevenLabsVoices
      .filter((v) => selectedVoiceMulti.some((val) => val.value == v.values))
      .map((m) => ({
        voiceActor: m.values,
        language: m.language,
        name: m.voice,
      }));
    saveIntegration({ features: objFeatures });
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <h3 className="mb-3">Voice & Behaviour Settings</h3>
          <p className="mb-4 text-muted">
            Configure the voice actors and behaviour settings for your
            PhoneSuite integration. Select your primary and supported voice
            actors, filter by language, and adjust advanced options as needed.
          </p>
          <div style={{ marginBottom: 24, maxWidth: 400 }}>
            <Label>Voice Actor (Primary)</Label>
            <Select
              components={{ Input: CustomSelectInput }}
              className="react-select"
              classNamePrefix="react-select"
              options={voiceActors.map((v) => ({
                value: v.values,
                label: `${v.voice} (${v.accent || 'N/A'}; ${v.language || 'N/A'})`,
              }))}
              value={
                voiceActors.length
                  ? voiceActors
                      .map((v) => ({
                        value: v.values,
                        label: `${v.voice} (${v.accent || 'N/A'}; ${v.language || 'N/A'})`,
                      }))
                      .find(
                        (opt) =>
                          opt.value === (features && features?.voiceActor)
                      )
                  : null
              }
              onChange={(selected) =>
                setFeatures((prev) => ({
                  ...prev,
                  voiceActor: selected ? selected.value : '',
                }))
              }
              isClearable
              placeholder="Select one voice actor..."
            />
          </div>
          {features?.voiceProcessing === 'ElevenLabs' &&
            features?.voiceActor !== '' && (
              // <Card className="mb-4" style={{ marginTop: 24 }}>
              //   <CardBody>
              //     <h5 className="mb-3">Primary Voice Actor</h5>
              <Table responsive bordered hover striped className="b-1">
                <thead className="thead-dark">
                  <tr>
                    <th>Voice Name</th>
                    <th>Accent</th>
                    <th>Gender</th>
                    <th>Language</th>
                    <th>Audio</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const selectedActor = elevenLabsVoices.find(
                      (v) => v.values === features.voiceActor
                    );
                    return selectedActor ? (
                      <tr>
                        <th scope="row" style={{ verticalAlign: 'middle' }}>
                          {selectedActor.voice}
                        </th>
                        <td style={{ verticalAlign: 'middle' }}>
                          {selectedActor.accent}
                        </td>
                        <td style={{ verticalAlign: 'middle' }}>
                          {selectedActor.gender}
                        </td>
                        <td style={{ verticalAlign: 'middle' }}>
                          {selectedActor.language}
                        </td>
                        <td style={{ verticalAlign: 'middle' }}>
                          <AudioPlayer
                            url={selectedActor?.preview_url}
                          ></AudioPlayer>
                        </td>
                      </tr>
                    ) : null;
                  })()}
                </tbody>
              </Table>
              //   </CardBody>
              // </Card>
            )}
          {features?.voiceProcessing === 'ElevenLabs' && (
            <div style={{ marginBottom: 16 }}>
              <Label for="elevenlabs-language-select">Filter by Language</Label>
              <Select
                id="elevenlabs-language-select"
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                options={Languages.map((lang) => ({
                  value: lang.code,
                  label: lang.name,
                }))}
                value={selectedLanguages}
                onChange={(selected) => setSelectedLanguages(selected)}
                isMulti
                isClearable
                placeholder="Select language(s)..."
                styles={{ container: (base) => ({ ...base, maxWidth: 300 }) }}
              />
            </div>
          )}

          <div style={{ marginBottom: 24, maxWidth: 400 }}>
            <Label>Supported Voice Actors (Multiple)</Label>
            <Select
              components={{ Input: CustomSelectInput }}
              className="react-select"
              classNamePrefix="react-select"
              options={filterSupportedVoicesByLanguage(
                elevenLabsVoices,
                selectedLanguages
              ).map((v) => ({
                value: v.values,
                label: `${v.voice} (${v.accent || 'N/A'}; ${v.language || 'N/A'})`,
              }))}
              value={selectedVoiceMulti}
              onChange={setSelectedVoiceMulti}
              isMulti
            />
          </div>

          {/* ...existing UI... */}
          {/* Table for selected primary voice actor */}

          {/* Table for selected multiple voice actors */}
          {features?.voiceProcessing === 'ElevenLabs' &&
            Array.isArray(selectedVoiceMulti) &&
            selectedVoiceMulti.length > 0 && (
              // <Card className="mb-4" style={{ marginTop: 24 }}>
              //   <CardBody>
              //     <h5 className="mb-3">Supported Voice Actors (Multiple)</h5>
              <Table responsive bordered hover striped className="b-1">
                <thead className="thead-dark">
                  <tr>
                    <th>Voice Name</th>
                    <th>Accent</th>
                    <th>Gender</th>
                    <th>Language</th>
                    <th>Audio</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedVoiceMulti.map((opt) => {
                    const actor = elevenLabsVoices.find(
                      (v) => v.values === opt.value
                    );
                    return actor ? (
                      <tr key={actor.values}>
                        <th scope="row" style={{ verticalAlign: 'middle' }}>
                          {actor.voice}
                        </th>
                        <td style={{ verticalAlign: 'middle' }}>
                          {actor.accent}
                        </td>
                        <td style={{ verticalAlign: 'middle' }}>
                          {actor.gender}
                        </td>
                        <td style={{ verticalAlign: 'middle' }}>
                          {actor.language}
                        </td>
                        <td style={{ verticalAlign: 'middle' }}>
                          <AudioPlayer url={actor?.preview_url}></AudioPlayer>
                        </td>
                      </tr>
                    ) : null;
                  })}
                </tbody>
              </Table>
              //</CardBody>
              // </Card>
            )}
          <div className="d-flex justify-content-center mt-4">
            <Button size="xs" onClick={handleSave} outline color="primary">
              Save
            </Button>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
}

export default VoiceAndBehaviour;
